var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-section',{attrs:{"title":"Publications"}},[_c('trombi',{attrs:{"list":_vm.sc.publications}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }